// Short Term pricing (camera included). Source: Snapshot_Live_Pricing_Comparison.xlsx, Oct 2026.
export const SHORT_TERM_CAMERA_COST = 295;
export const SHORT_TERM_IMAGE_RATE = 0.49;
export const DAYS_PER_YEAR = 365;
export const WEEKS_PER_YEAR = 52;
export const WEEKS_PER_QUARTER = 13;

export const SHORT_TERM_PACKAGES = [
  { name: "Core", imagesPerDay: 4 },
  { name: "Pro", imagesPerDay: 6 },
  { name: "Plus", imagesPerDay: 8 },
  { name: "Max", imagesPerDay: 12 },
] as const;

export type ShortTermMonths = 3 | 12;

export const termWeeks = (months: ShortTermMonths) => (months === 3 ? 13 : 52);

const ceilHalf = (n: number) => Math.ceil(Math.round(n * 1e6) / 1e6 / 0.5) * 0.5;

export function shortTermWeeklyPerCamera(imagesPerDay: number, months: ShortTermMonths): number {
  const exact =
    ((imagesPerDay * DAYS_PER_YEAR) / WEEKS_PER_YEAR) * SHORT_TERM_IMAGE_RATE +
    SHORT_TERM_CAMERA_COST / termWeeks(months);
  return ceilHalf(exact);
}

export function shortTermQuote(cameras: number, imagesPerDay: number, months: ShortTermMonths) {
  const qty = Math.max(1, Math.floor(cameras || 1));
  const weeks = termWeeks(months);
  const weeklyPerCamera = shortTermWeeklyPerCamera(imagesPerDay, months);
  const weekly = weeklyPerCamera * qty;
  return {
    cameras: qty,
    imagesPerDay,
    termMonths: months,
    termWeeks: weeks,
    weeklyPerCamera,
    quarterlyPerCamera: weeklyPerCamera * WEEKS_PER_QUARTER,
    annualPerCamera: weeklyPerCamera * WEEKS_PER_YEAR,
    weekly,
    quarterly: weekly * WEEKS_PER_QUARTER,
    annual: weekly * WEEKS_PER_YEAR,
    contractTotal: weekly * weeks,
    totalImages: Math.round(((imagesPerDay * DAYS_PER_YEAR) / WEEKS_PER_YEAR) * weeks) * qty,
  };
}
